<script lang="ts">
  import report from './img/icon-report.png'
  import Modal from '../Modal/Modal.svelte'
  import style2String, { style2StringObj } from '../../plugins/style2String'
  export let clickEnrey
  export let rootFontSize
  export let position
  interface entryStyleObj extends style2StringObj {
    iconColor?: string,
    iconWidth?: string | number,
    iconHeight?: string | number,
  }

  export let entryStyle: entryStyleObj = {}
  let showPopup
</script>

<style lang="less" src="./Entry.less">
</style>
  
<div 
  class="entry" 
  on:click={() => showPopup = true} 
  style={`
    font-size: ${rootFontSize};
    left:   ${position.left   || 'unset'};
    right:  ${position.right  || 'unset'};
    top:    ${position.top    || 'unset'};
    bottom: ${position.bottom || 'unset'};
    z-index:${position.zIndex ||  9999999};
    ${style2String(entryStyle)}
  `}
>
  <!-- <img src={more} alt=""> -->
  <svg style="fill:{entryStyle.iconColor || '#fff'};width:{entryStyle.iconWidth || '55%'};height:{entryStyle.iconHeight || '55%'}" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20154" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><style type="text/css"></style></defs><path d="M409.113 95.852h-299.65c-24.82 0-44.947 20.137-44.947 44.956v299.62c0 24.82 20.127 44.957 44.947 44.957h299.65c24.79 0 44.945-20.137 44.945-44.956V140.808c0-24.82-20.156-44.956-44.945-44.956zM869.771 556.522h-299.66c-24.82 0-44.936 20.116-44.936 44.935v299.64c0 24.821 20.116 44.937 44.937 44.937h299.66c24.8 0 44.936-20.116 44.936-44.936v-299.64c0-24.82-20.137-44.936-44.937-44.936zM937.536 210.565L695.37 82.722c-20.035-10.588-44.876-2.902-55.483 17.114L512.025 342.049c-10.568 20.077-2.892 44.877 17.174 55.505l242.174 127.823c20.056 10.588 44.936 2.902 55.524-17.135L954.72 266.07c10.599-20.076 2.922-44.916-17.184-55.504zM409.113 556.522h-299.65c-24.82 0-44.947 20.116-44.947 44.935v299.64c0 24.821 20.127 44.937 44.947 44.937h299.65c24.79 0 44.945-20.116 44.945-44.936v-299.64c0-24.82-20.156-44.936-44.945-44.936z" p-id="20155"></path></svg>
</div>
<Modal 
  bind:isOpen={showPopup} 
  mainStyle="align-items: flex-end;{`font-size: ${rootFontSize}`}" 
  wrapperStyle="height: 25%;border-radius: 20px 20px 0 0;" 
  contentStyle="height: 100%" 
  flyDistance={50}
  showCloseIcon={false}
  zIndex={entryStyle.zIndex || position.zIndex}
>
  <div slot="content" let:close={close} class="popup-content">
    <div class="report-entry" on:click={clickEnrey}>
      <img src={report} alt="" class="icon" >
      <div>举报</div>
    </div>
  </div>
</Modal>